@if (values.length > 0) {
<table class="table collection-type-field-control-table">
  <thead class="header-row">
    <tr>
      <th class="col-1"></th>
      @if (columnsFields | async; as columnsFields) { @for (column of
      columnsFields | keyvalue: keyAscOrder; track column) {
      <th [class]="classListColumn(column.value)">
        {{ column.value.attributes.label }}
      </th>
      } }
      <th class="col-1 justify-content-between align-items-center">Actions</th>
    </tr>
  </thead>
  <tbody>
    @for (collection of values; track collection; let indexCollection = $index)
    {
    <tr class="">
      <th>{{ indexCollection + 1 }}.</th>
      @if (collection.fields | async; as fields) { @for (field of fields |
      keyvalue: keyAscOrder; track field) {
      <td class="">
        @if (field.value.attributes.display_type == 'radioSwitch') {
        <label class="d-flex align-items-center">
          <input
            type="radio"
            [name]="field.value.name"
            [value]="collection.collectionId"
            [formControl]="field.value.control"
            (change)="onRadioSwitchChange(collection.collectionId)"
          />
          <span class="radio-option"></span>
        </label>
        } @else {
        <field-control [field]="field.value" class="medium"></field-control>
        }
      </td>
      } }
      <td>
        <a (click)="removeValue(indexCollection)">
          <icon type="mat_remove_circle" color="red"></icon>
        </a>
        @if ((indexCollection + 1) == values.length) {
        <a (click)="addEmptyValue()">
          <icon type="mat_add_circle" color="blue"></icon>
        </a>
        }
      </td>
      <!--    <array-field-controls-->
      <!--      *ngIf="!disabled"-->
      <!--      [canRemove]="canRemove"-->
      <!--      [canAdd]="last"-->
      <!--      (add)="addEmptyValue()"-->
      <!--      (remove)="removeValue(value)"-->
      <!--    ></array-field-controls>-->
    </tr>
    }
  </tbody>
</table>
}
